export const USER_PREFERENCES_DATA_NAME: string = 'userData';
export const MARKET_DATA_QUERY_YEAR_LIMIT: number = 15;
